interface OptionsProps {
  template: string,
  // eslint-disable-next-line camelcase
  page_section: string,
  description: string,
}

interface ReturnType {
  areaName: string,
  method: string,
}

export function eventNameBuilder(options: OptionsProps): ReturnType {
  // ({app}.)({fe}.){file location}(.{page section}).{description, type, etc}(.default)
  const { template, description } = options;
  const pageSection = options.page_section;
  let method;
  if (pageSection) {
    method = ['fe', template, pageSection, description].join('.');
  } else {
    method = ['fe', template, description].join('.');
  }
  return {
    areaName: `${template}.apply`,
    method,
  };
}

export default eventNameBuilder;
